export default __webpack_public_path__ + "static/media/arrowRight.dd9a76c4.svg";